import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Flows = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Flows' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M5 2C3.34315 2 2 3.34315 2 5V8C2 9.65685 3.34315 11 5 11H19C20.6569 11 22 9.65685 22 8V5C22 3.34315 20.6569 2 19 2H5ZM4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V8C20 8.55228 19.5523 9 19 9H5C4.44772 9 4 8.55228 4 8V5ZM5 13C3.34315 13 2 14.3431 2 16V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V16C22 14.3431 20.6569 13 19 13H5ZM4 16C4 15.4477 4.44772 15 5 15H19C19.5523 15 20 15.4477 20 16V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V16Z' fill='#000' />
  </StyledIcon>
);
